import { Autocomplete, Box, Chip, DialogActions, FormControl, FormHelperText, TextField, Typography } from "@mui/material";
import MaterialInput from "../../components/MaterialInput";
import MaterialSelect from "../../components/MasterSelect";
import MaterialButton from "../../components/MaterialButton";
import Grid from "@mui/material/Grid2"

const Onboarding = ({ recruitmentdata, allmails,
  setOpen, setInputValue, inputValue, handlerecruitmentchange, handleOnboarding }) => {

    const checkAllFields = () => {
      let allowSubmit = false;
      if(recruitmentdata?.todataStatus === "success" &&
        recruitmentdata?.onboardccmailStatus === "success" &&
        recruitmentdata?.contentStatus === "success"
      ){
        allowSubmit = true;
      }
      else{
        allowSubmit = false;
      }
      return allowSubmit;
    }

  return (
    <>
      <Grid container spacing={1}>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            From <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            name="Jobid"
            value="KEELIS"
            disabled
            size='small'
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            To <span style={{ color: "red" }}>*</span>
          </Typography>

          <MaterialSelect
            name="todata"
            value={recruitmentdata?.onboardtoemail}
            onChange={(e) => handlerecruitmentchange("onboardtoemail", e)}
            error={recruitmentdata.todataStatus === "error"}
            success={recruitmentdata.todataStatus === "success"}
            size='small'
            options={allmails.map((val) => {
              return {
                value: val.value,
                label: val.label,
              };
            })}
          />
          {recruitmentdata.todataStatus === "error" && (
            <FormControl error>
              <FormHelperText>
                Please enter a valid email address
              </FormHelperText>
            </FormControl>
          )}
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            CC <span style={{ color: "red" }}>*</span>
          </Typography>

          <Autocomplete
            multiple
            freeSolo
            options={allmails}
            getOptionLabel={(option) => option.label}
            error={recruitmentdata.ccdataStatus === "error"}
            success={recruitmentdata.ccdataStatus === "success"}
            value={recruitmentdata?.onboardccmail}
            onChange={(e, value) => handlerecruitmentchange("onboardccmail", value)}
            inputValue={inputValue}
            onInputChange={(event, newInputValue) =>
              setInputValue(newInputValue)
            }
            size='small'
            filterSelectedOptions
            renderInput={(params) => (
              <TextField
                {...params}
                variant="outlined"
                size='small'
              // label="Select or Type"
              // placeholder="Press Enter, Space, or Comma to add"
              // onKeyDown={handleKeyDown} // Capture key presses
              />
            )}
            renderTags={(tagValue, getTagProps) =>
              tagValue.map((option, index) => (
                <Chip
                  key={option.value}
                  label={option.label}
                  {...getTagProps({ index })}
                />
              ))
            }
            isOptionEqualToValue={(option, value) =>
              option.value === value.value
            }
          />
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Typography variant="caption">
            Content <span style={{ color: "red" }}>*</span>
          </Typography>
          <MaterialInput
            name="content"
            multiline
            rows={3}
            value={recruitmentdata?.onboardcontent}
            onChange={(e) => handlerecruitmentchange("onboardcontent", e.target.value)}
            error={recruitmentdata?.contentStatus === "error"}
            success={recruitmentdata?.contentStatus === "success"}
          />
        </Grid>
      </Grid>

      <DialogActions sx={{ justifyContent: "center" }}>
        <MaterialButton
          onClick={() => setOpen(false)}
          variant="gradient"
          color="dark"
          size='small'
        >
          Cancel
        </MaterialButton>
        <MaterialButton
          variant="gradient"
          color="dark"
          disabled={!checkAllFields()}
          onClick={handleOnboarding}
          size='small'
        >
          Submit
        </MaterialButton>
      </DialogActions>
    </>
  )
}

export default Onboarding